import { useState, useMemo } from 'react'
import { Popup } from 'react-map-gl'
import type { Properties } from '../types'
import { Pin } from './Pin'

interface Location {
  latitude: number
  longitude: number
  name: string
}

interface PinsProps {
  data: GeoJSON.FeatureCollection<GeoJSON.Point, Properties>
}

export const Pins: React.FC<PinsProps> = ({ data }) => {
  const [popupInfo, setPopupInfo] = useState<Location | null>(null)

  const pins = useMemo(
    () =>
      data.features.map((feature, index) => {
        const [longitude, latitude] = feature.geometry.coordinates
        const name = feature.properties.name
        const color = feature.properties.color
        return <Pin key={`marker-${index}`} coordinates={{ latitude, longitude }} onClick={() => setPopupInfo({ latitude, longitude, name })} color={color} />
      }),
    [data]
  )
  return (
    <>
      {pins}

      {popupInfo ? (
        <Popup anchor="top" longitude={Number(popupInfo.longitude)} latitude={Number(popupInfo.latitude)} onClose={() => setPopupInfo(null)}>
          <h5>{popupInfo.name}</h5>
        </Popup>
      ) : null}
    </>
  )
}
